<template>
  <div class="mod-overlay">
    <div class="mod-modal">
      <!-- Header -->
      <div class="mod-modal-header">
        <h3 class="mod-modal-title">
          <i :class="isEdit ? 'bi bi-pencil' : 'bi bi-plus-circle'"></i>
          {{ isEdit ? 'Editar condición de pago' : 'Nueva condición de pago' }}
        </h3>
        <button class="mod-modal-close" @click="$emit('close')">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <!-- Body -->
      <form @submit.prevent="handleSubmit" class="mod-modal-body">
        <div v-if="error" class="mod-alert-error">
          <i class="bi bi-exclamation-triangle-fill"></i>
          {{ error }}
        </div>

        <div class="mod-form-grid">
          <div class="mod-field">
            <label for="Clave">Clave <span class="mod-required">*</span></label>
            <input type="text" id="Clave" v-model="form.Clave" :disabled="isEdit" required maxlength="50" placeholder="Código de la condición">
          </div>

          <div class="mod-field">
            <label for="Nombre">Nombre <span class="mod-required">*</span></label>
            <input type="text" id="Nombre" v-model="form.Nombre" required placeholder="Nombre de la condición">
          </div>

          <div class="mod-field">
            <label for="DiasCredito">Días de Crédito</label>
            <input type="number" id="DiasCredito" v-model.number="form.DiasCredito" placeholder="0" min="0">
          </div>

          <div class="mod-field">
            <label for="ClaveErp">Clave ERP</label>
            <input type="text" id="ClaveErp" v-model="form.ClaveErp" placeholder="Mapeo con sistema ERP">
          </div>

          <div class="mod-field mod-field-check">
            <label class="mod-check-label">
              <input type="checkbox" v-model="form.EsActivo">
              <span>Activo</span>
            </label>
          </div>
        </div>

        <!-- Footer -->
        <div class="mod-modal-footer">
          <button type="button" class="mod-btn mod-btn-cancel" @click="$emit('close')">Cancelar</button>
          <button type="submit" class="mod-btn mod-btn-save" :disabled="saving">
            <span v-if="saving" class="mod-spinner-sm"></span>
            <template v-else>
              <i class="bi bi-check-lg"></i>
              {{ isEdit ? 'Guardar cambios' : 'Crear condición' }}
            </template>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import condicionPagoService from './condicionpago.service';
import { showToast } from '@/shared/utils/toast';
import authService from '@/services/auth';
import { createCondicionPago } from './condicionpago.model';

export default {
  name: 'CondicionPagoForm',
  props: {
    item: { type: Object, default: null },
    isEdit: { type: Boolean, default: false }
  },
  emits: ['saved', 'close'],
  data() {
    return {
      form: createCondicionPago(),
      saving: false,
      error: null
    };
  },
  created() {
    if (this.isEdit && this.item) {
      this.form = { ...this.item };
    } else {
      const empresa = authService.getSelectedEmpresa();
      this.form.EmpresaId = empresa?.EmpresaId || 0;
    }
  },
  methods: {
    async handleSubmit() {
      this.saving = true;
      this.error = null;
      if (!this.form.Clave || !this.form.Nombre) {
        this.error = 'Clave y Nombre son obligatorios';
        this.saving = false;
        return;
      }
      try {
        const result = await condicionPagoService.guardar(this.form);
        if (result.Number >= 0) {
          showToast(result.Message || 'Guardado correctamente', result.Type || 'success');
          this.$emit('saved');
        } else {
          this.error = result.Message || 'Error al guardar';
        }
      } catch (e) {
        console.error('Error al guardar:', e);
        this.error = 'Error de conexión con el servidor';
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
@import "@/modules/_shared/catalog.css";
</style>
